module.exports = __webpack_public_path__ + "img/Z30.41670ba8.png";